// TODO: validate
export const MOBILE_MEDIA_QUERY = "(max-width: 640px)" as const;
export const TABLET_MEDIA_QUERY = "(max-width: 1024px)" as const;
